import styled from "styled-components";

export const StyledDocsAutomatorLoopingGroup = styled.div`
  list-style: none;
  display: grid;
`;
